import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation reorderTopOffersMutation($input: ReorderTopOffersInput!) {
    reorderTopOffers(input: $input) {
      lists {
        ...TopOffersContainer_lists
      }
    }
  }
`;

const reorderTopOffers = (environment, ids, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: { ids },
    },
    ...args,
  });
};

export default reorderTopOffers;
